package com.downdogapp.client

import com.downdogapp.client.FirstDayOfWeek.MONDAY
import com.downdogapp.client.FirstDayOfWeek.SUNDAY
import kotlinx.browser.window
import kotlin.js.Date

actual object CalendarHelper {

  private val YearMonth.date: Date
    get() =
      Date(year, month)

  private val YearMonthDay.date: Date
    get() =
      Date(year, month, day)

  private val locale = window.asDynamic().Intl.DateTimeFormat().resolvedOptions().locale as String

  actual val today: YearMonthDay
    get() =
      yearMonthDayFromMillis(Date.now().toLong())

  // Date(day = 0) will produce the last day of the previous month
  actual fun numDaysInMonth(yearMonth: YearMonth) =
    YearMonthDay(yearMonth.nextMonth(), 0).date.getDate()

  actual fun monthNameShort(yearMonth: YearMonth) =
    yearMonth
      .date
      .toLocaleDateString(
        locales = locale,
        options = dateLocaleOptions {
          month = "short"
        }
      )

  actual fun monthYearNameLong(yearMonth: YearMonth) =
    yearMonth
      .date
      .toLocaleDateString(
        locales = locale,
        options = dateLocaleOptions {
          month = "long"
          year = "numeric"
        }
      )

  actual fun dayOfWeek(yearMonthDay: YearMonthDay, firstDayOfWeek: FirstDayOfWeek) =
    yearMonthDay.date.getDay().let {
      when (firstDayOfWeek) {
        SUNDAY -> it
        MONDAY -> (yearMonthDay.date.getDay() + 6) % 7
      }
    }

  actual fun yearMonthDayFromMillis(timestamp: Long): YearMonthDay {
    val date = Date(milliseconds = timestamp)
    return YearMonthDay(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    )
  }

  actual fun yearMonthDayFromSeconds(timestamp: Double) =
    yearMonthDayFromMillis((timestamp * 1000).toLong())

  actual fun weekdayName(yearMonthDay: YearMonthDay) =
    yearMonthDay
      .date
      .toLocaleDateString(
        locales = locale,
        options = dateLocaleOptions {
          weekday = "narrow"
        }
      )
}
